import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

export const TRANSACTION_VOLUME_LINE_CHART_MOCK_DATA: Chart = createSingleSeriesTimeSeriesMockData({
    seriesName: 'Transactions'
});
